import React from 'react'
import styled from 'styled-components'
import { Badge } from '../../components/Badge'

const StyledSchoolResultBadge = styled(Badge).attrs({
  titleBackgroundColor: '#ee8d20',
  textBackgroundColor: '#fde2c0',
})``

interface ISchoolResultBadgeProps {
  title: string
  className?: string
  results?: string | number
  suffix?: string
  style?: React.CSSProperties
}

const SchoolResultBadge: React.FC<ISchoolResultBadgeProps> = ({
  title,
  className,
  results,
  suffix = '',
  style,
}) => {
  if (!results) {
    return null
  }
  return (
    <StyledSchoolResultBadge style={style} title={title} className={className}>
      {`${results}${suffix}`}
    </StyledSchoolResultBadge>
  )
}

export { SchoolResultBadge }
